import { St } from './Status.jsx';

/**
 * Op welke threat-intel-lijst een adres staat (docs/besluiten/threat-intel.md), als labels in de kleur van hoe zwaar het
 * weegt: een server die botnets aanstuurt kritiek, een DROP-netwerk hoog, een bekende aanvaller midden. In de tooltip
 * wat de lijst erbij zegt (de malware, het SBL-nummer).
 */
const SOORT = { c2: 'critical', drop: 'serious', aanvaller: 'warning' };

export default function Lijsten({ lijsten }) {
  if (!lijsten?.length) return null;
  return (
    <span className="lijsten">
      {lijsten.map((l) => <span key={l.id} title={l.ref ? `${l.naam}: ${l.ref}` : l.naam}><St soort={SOORT[l.soort] ?? 'neutral'}>{l.naam}</St></span>)}
    </span>
  );
}
